export const scrollToID = (id) => {
  const element = document.getElementById(id)
  element.scrollIntoView({ behavior: 'smooth' })
}



// WEBPACK FOOTER //
// ./src/common/lib/static-page/dom-helper.js